import { Link, navigate } from 'gatsby'

import { FaqRoutingProvider } from '@karakuri-web/faq-component'

import type { WrapRootElementBrowserArgs, WrapRootElementNodeArgs } from 'gatsby'

export function wrapRootElement({ element }: WrapRootElementBrowserArgs | WrapRootElementNodeArgs) {
  return (
    <FaqRoutingProvider navigate={navigate} Link={Link}>
      {element}
    </FaqRoutingProvider>
  )
}
